// Use the installed Stremio server's existing conversion mode when a provider
// declares a source unsuitable for web, or HTTPS would block an HTTP video.
// This is not a probe or a verdict: the original engine handles the result.
function needsServerConversion({ stream, serverURL, pageProtocol, shellActive, casting }) {
    if (!serverURL || shellActive || casting || !stream?.url || stream.infoHash || stream.ytId || stream.externalUrl) return false;
    try {
        const url = new URL(stream.url);
        if (!['http:', 'https:'].includes(url.protocol)) return false;
        return stream.behaviorHints?.notWebReady === true || pageProtocol === 'https:' && url.protocol === 'http:';
    } catch (_) { return false; }
}
// Some server versions cannot expose /settings to custom web origins. For a
// source that cannot be loaded directly, use the configured transport and let
// the original engine perform its own probe/conversion instead of falling back
// to an HTTP video on an HTTPS page.
function selectStreamingServerURL({ server, configuredURL, stream, pageProtocol, shellActive, casting }) {
    if (casting) return server.baseUrl || null;
    const transport = server.selected?.transportUrl || configuredURL;
    if (server.baseUrl) return transport || null;
    return needsServerConversion({ stream, serverURL: transport, pageProtocol, shellActive, casting })
        ? transport : null;
}
module.exports = needsServerConversion;
module.exports.selectStreamingServerURL = selectStreamingServerURL;
